import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@Store/index';
import { requestTypeOptionsAllowed } from '@Features/store/selectors/requestTypeOptionsAllowed';
import { prepareApprovalReqTypeOptions } from '@Utils/transformToOptions';

import { getRequestTypeDictSelector } from './dictionarySelector';
import { tasksCountSelector } from './headerSelector';
import { OptionExtended } from '@Components/types/options';

const approvalsList = (state: RootState) => state.common.approvalsList;

const currentApprovalsList = createSelector(
  approvalsList,
  ({ approvalsList }) => approvalsList
);

const stateOpenApproveModal = createSelector(
  approvalsList,
  ({ openModalApprove }) => openModalApprove
);

const stateOpenRejectModal = createSelector(
  approvalsList,
  ({ openModalReject }) => openModalReject
);

const getApprovalReqTypeOptions = createSelector(
  [getRequestTypeDictSelector, tasksCountSelector],
  (requestTypeDict, tasksCount) => {
    const requestTypeDictFiltered = requestTypeDict.filter(
      (requestType) => requestTypeOptionsAllowed[requestType.codeNum]
    );

    const requestTypeOptions = prepareApprovalReqTypeOptions(
      requestTypeDictFiltered,
      tasksCount
    );

    const allTasksCount = requestTypeOptions.reduce((acc, item) => {
      const currentCount = item.description || 0;
      return acc + currentCount;
    }, 0);
    const defaultOption: OptionExtended = {
      value: '',
      label: 'All',
      description: allTasksCount,
    };
    return [defaultOption, ...requestTypeOptions];
  }
);

export {
  currentApprovalsList,
  stateOpenApproveModal,
  stateOpenRejectModal,
  getApprovalReqTypeOptions,
};
